import * as React from "react";
import { DatePickerProps } from "antd/lib/date-picker/interface";
import { DatePicker } from "antd";
import locale from "antd/lib/date-picker/locale/pt_BR";
import * as moment from "moment";
import "moment/locale/pt-br";
import { FormItemProps } from "antd/lib/form/FormItem";
import { WrappedFormUtils } from "antd/lib/form/Form";
import "./PbrInputDate.scss";
import { PbrFormItem } from "../PbrFormItem/PbrFormItem";

export interface IPbrInputDateProps extends DatePickerProps {
  name?: string;
  error?: boolean;
  isRequired?: boolean;
  rules?: any[];
  formWrapper?: WrappedFormUtils;
  formItemProps?: FormItemProps;
  requiredMessage?: string;
  placeholder?: string;
}

export class PbrInputDate extends React.Component<IPbrInputDateProps> {
  public render() {
    moment.locale("pt-BR");
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const getFieldDecorator = this.props.formWrapper ? this.props.formWrapper.getFieldDecorator : null;

    const props = { ...this.props };
    const formItemProsp = this.props.formItemProps;
    const value = props.value ? moment(props.value) : undefined;
    delete props.value
    return (
      <PbrFormItem {...formItemProsp} className="pbr-standard-input">
        {getFieldDecorator &&
          getFieldDecorator(props.name, { rules: [{ required: props.isRequired, message: props.requiredMessage }], initialValue: value })(
            <DatePicker size={"large"} style={{ width: "100%" }} locale={locale} format={dateFormatList[0]} placeholder={props.placeholder} {...props} />
          )}
      </PbrFormItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputDate/PbrInputDate.tsx